<script>
  import { _ } from 'svelte-i18n';
  import { onMount, onDestroy, createEventDispatcher } from 'svelte';
  import { listsNotices } from './Services/noticeListServices';
  import { notices_list, next_page_notices } from './stores';
  import { throttle } from '../../../helpers';

  import Notice from '../../custom/Notice.svelte';

  export let isGreenFlow;

  const dispatch = createEventDispatcher();

  let scrollContainer = null;

  const removeScrollListener = () => {
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', throttledScroll);
    }
  }

  const scrollNoticeHandler = async () => {
    if (!scrollContainer) {
      return;
    }

    const offsetClientHeight = 300;
    const isScrollToBottomPosition = scrollContainer.scrollTop + scrollContainer.clientHeight + offsetClientHeight >= scrollContainer.scrollHeight;

    if (isScrollToBottomPosition) {
      if (!$next_page_notices) {
        return;
      }

      await listsNotices($next_page_notices.split('=')[1]);
    }
  }

  const throttledScroll = throttle(scrollNoticeHandler, 500);

  const handleVisibleNotice = (e) => {
    const noticeId = e.detail.noticeId;

    $notices_list = $notices_list.map((notice) => {
      if (notice.id === noticeId) {
        return {
          ...notice,
          is_hidden: !notice.is_hidden,
        }
      }

      return notice;
    });
  }

  onMount(async () => {
    await listsNotices();

    scrollContainer = document.querySelector('.popup_notice');

    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', throttledScroll);
    }
  });

  onDestroy(() => {
    notices_list.set([]);
    next_page_notices.set(null);
    removeScrollListener();
  });
</script>

<div class="main">
  {#each $notices_list as notice (notice.id)}
    <Notice 
      {notice}
      {isGreenFlow}
      on:handle-visible={handleVisibleNotice}
      on:hide-modal={() => dispatch('hide-modal')}
    />
  {/each}
</div>

{#if !$next_page_notices}
  <div class="end">{$_('LatestNotifications')}</div>
{/if}

<style>
  .end {
    padding: 20px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: rgba(90, 95, 109, 0.6);
  }
</style>